/*eslint-disable*/
import axios from "axios";
import apiConfig from './api.config';
class HitoDataService {
    getAll() {
        return axios.get(`/pdis?populate=*`, apiConfig.connData());
    }
    get(id) {
        return axios.get(`/pdis/${id}?populate=*`, apiConfig.connData());
    }
    getHitoFromPDI(id) {
        const qs = require('qs');
        const query = qs.stringify({
            filters: {
                id: {
                    $eq: id,
                },
            },
            populate: '*',
        });

        //return request(`/api/pdis?${query}`);
        return axios.get(`/pdis?${query}`, apiConfig.connData());
    }
    getByPDI(pdi_id) {
        const qs = require('qs');
        const query = qs.stringify({
            filters: {
                id: {
                    $eq: pdi_id,
                },
            },
            populate: '*',
        });

        //return request(`/api/pdis?${query}`);
        return axios.get(`/pdis?${query}`, apiConfig.connData());
    }
}
export default new HitoDataService();